// tools function
export default {


  // format numbers
  fm(num, delim, k) {
    if (isNaN(num)) return ''
    if (k) {
      num = Math.round(num / 1000)
      return num + 'k'
    }
    if (!delim) delim = ' '
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, delim)
  },

  //use:
  //many(42, 'найдена', 'найдено', 'найдены');
  many(num, one, five, many) {    
    let cases = [2, 0, 1, 1, 1, 2];
    let id = (num % 100 > 4 && num % 100 < 20) ? 2 : cases[(num % 10 < 5) ? num % 10 : 5]
    switch (id) {
      case 0: return one
      case 1: return five
      case 2: return many
    }
  },

  /* eslint-disable */
  percents(v){
    if (!v) return 0
    if (v > 99) return Math.round(v)
    let p = Number(v)
    if (!p || p == 0) return 0
    let res = p.toFixed(2)
    return res
  },
  
  sign(v){    
    if (v > 0) return '+'
    if (v < 0) return '-'
    return ''
  },


}